const SaveButtonIcon = () => (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="14" cy="14" r="13" />
		<path d="M10.5 8.5V19.5L14 17.5L17.5 19.5V8.5Z" strokeLinejoin="round" />
	</svg>
);

export default SaveButtonIcon;
